module.exports = __webpack_public_path__ + "static/media/Resurs 490.846bd9a2.png";